<template>
	<router-view></router-view>
</template>
<script>
	export default {
		data() {
			return {
				
			}
		},
		onLoad() {
			
		},
		methods: {
			
		}
	}
</script>

<style>
	body{
		margin: 0;
		touch-action: pan-x pan-y !important;
		/* 禁止双指缩放 */
		-webkit-user-drag: none !important;
		/* 禁止双指拖曳 */
		
		/* IOS禁止微信调整字体大小 */
		 -webkit-text-size-adjust: 100% !important;
		 text-size-adjust: 100% !important;
		 -moz-text-size-adjust: 100% !important;
	}
</style>